export enum ConfirmDialogDataTypeEnum {
  DEFAULT,
  INFO
}

export interface IConfirmDialogData {
  title: string;
  message: string;
  type?: ConfirmDialogDataTypeEnum;
}
